"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteStateRecord = void 0;
var immutable_1 = require("immutable");
var core_1 = require("@gin-betting/core");
exports.FavoriteStateRecord = immutable_1.Record({
    favoriteIds: immutable_1.OrderedSet(),
    fetchStatus: core_1.App.FetchStatus.INITIAL,
}, 'FavoriteState');
//# sourceMappingURL=types.js.map